import React, { useEffect, useMemo, useState } from 'react';
import {
  getResourceApi,
  ShiftSearchDayCountRequestWithDataPref,
} from '@erecruit/modules';
import {
  Flex,
  DayPickerProps,
  H3,
  DayInfo,
  SevenItems,
} from '@erecruit/ui-kit';
import { Resources, ResolverResponse } from '@erecruit/types';

const fullWeek = 7;

export function useShiftCalendarCount(
  searchParams: Partial<Resources.ShiftSearchFilter>,
): [DayPickerProps['infos'], boolean] {
  const [shiftCalendarCount, setShiftCalendarCount] = useState(
    [] as Resources.ShiftSearchDayCount[],
  );
  const [isLoadingShiftCount, setIsLoadingShiftsCount] = useState(false);

  useEffect(() => {
    const fetch = async () => {
      try {
        const responses = await getResourceApi().getResources([
          new ShiftSearchDayCountRequestWithDataPref({
            filter: {
              startDates: searchParams.startDates || [],
            },
          }),
        ]);

        const response = responses[0] as ResolverResponse;

        if (response.success) {
          const data = responses[0].data as Resources.ShiftSearchDayCount[];

          setShiftCalendarCount(data);
          setIsLoadingShiftsCount(false);
        }
      } catch (e) {
        console.error(e);
        setIsLoadingShiftsCount(false);
      }
    };

    if (
      searchParams.startDates &&
      searchParams.startDates.length === fullWeek
    ) {
      setIsLoadingShiftsCount(true);
      fetch();
    }
  }, [searchParams]);

  const shiftCountInfos = useMemo(() => {
    return shiftCalendarCount.map(calendarCount => ({
      progress: {
        current: calendarCount.filledShifts,
        total: calendarCount.totalShifts,
      },
      tooltip: (
        <Flex direction="column" gutter={2} gutterDirection="vertical">
          <Flex gutter={1} gutterDirection="horizontal">
            <H3 weight={700}>
              {calendarCount.filledShifts}/{calendarCount.totalShifts}
            </H3>
            <H3 weight={400}>candidates</H3>
          </Flex>
        </Flex>
      ),
    })) as SevenItems<DayInfo>;
  }, [shiftCalendarCount]);

  return [shiftCountInfos, isLoadingShiftCount];
}
